 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~w~39769c46","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","7":"buybox~quick-view~write-a-review-form","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~emt-generated-content","15":"buybox~quick-view","16":"buybox~super-sku","17":"media-gallery-overlay~media-gallery-overlay-mobile","18":"promotion-products-lazy~quick-view","19":"quick-view~write-a-review-form","22":"StoreLayout","23":"add-to-list-drawer","24":"aisle-bay","25":"augmented-reality","26":"bath-renovation","27":"breadcrumbs","28":"browse-and-search","29":"browse-and-search-mobile","30":"buybox","31":"calculator-pipcalculator","32":"collections","33":"collections-mobile","34":"compare","35":"consumer-card-messaging","36":"customer-image-overlay","37":"drawer","38":"emt-generated-content","39":"emt-links","40":"fbr","41":"global-custom-configurator","42":"hammerjs","44":"home","45":"magic-apron","46":"measurement-guide","47":"measurement-guide-overlay-content","48":"media-gallery-filmstrip-mobile","49":"media-gallery-overlay","50":"media-gallery-overlay-mobile","51":"message-types","52":"orange-lens","53":"order-sample","54":"order-sample-drawer","55":"overlay","56":"paint-reorder","57":"paint-reorder-mobile","58":"pep","59":"pep-mobile","60":"product","61":"product-mobile","62":"product-overview","63":"promotion-products-lazy","64":"question","65":"questions-and-answers","66":"quick-view","67":"ratings-and-reviews","68":"ratings-and-reviews-desktop","69":"ratings-and-reviews-mobile","70":"results","71":"returns-messaging","73":"share-to-email-overlay","74":"share-to-pinterest-overlay","75":"size-guide-overlay","76":"specifications","77":"stylequiz","78":"super-sku","79":"vendor-collection-products","80":"vendor-collections","81":"vendor-collections-mobile","83":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"2844875e4b110ea6e675","1":"f27a852767b8d3b8e7fe","2":"c655823a675e28652240","3":"d6d041d67c0b8573080d","4":"ab0743e0cdc03faac3e1","5":"86556186e12186b18f97","6":"01d70fbbbe2b90968d41","7":"f05469d16e4eba4bd587","8":"55f43009fae4f9944476","9":"dc4a7a48543fc295c1d1","10":"fa820a5e8b2d4ec8c1c7","11":"a292142cac181412ba96","12":"1fb66f401c55d3aa2c21","13":"cc04938657bea1fd1d32","14":"02a73232e8dfd76b1dbd","15":"2e5291660a66e214243d","16":"df5178013d9bb7c2343b","17":"4d4db31a140664788a05","18":"b0cdbedfb0082b4a190e","19":"7ded98dde84572192030","20":"9e47d0172d11aee4c7a9","21":"1e4d5e4c9f1360307af8","22":"b4772828cb9ae3cb0fee","23":"083fe4d1a34247d6949a","24":"fc3c48781e3247bad35d","25":"2f1c60e9ebd81140b165","26":"3a80752e1f5ea599d845","27":"29e66f5d7a7a52a55206","28":"695e4a38b63531fb0242","29":"d95e2c45f71244b52ccf","30":"e4b8a69e8827c6ac4719","31":"67aa7d8e3e24ca15f3b5","32":"5a68b6616d3834e34e39","33":"d9e016c78240fb562809","34":"147770a04cb7069b2a61","35":"b3f76e82378e2370b9a1","36":"8572209ff35c50dfb7c2","37":"dcf9f09308cb925ca06d","38":"d75b74712540e14f1700","39":"7046e1997f514297afae","40":"dd36503004558fa7ab15","41":"4a7d5eef7c69a86f5bac","42":"2c3dc72e0d3c24e9f089","44":"3909de253cf6ef19abbf","45":"68815f84542c395b5157","46":"9e0afedd4b7a64a7807e","47":"7d528477ab476a9b488a","48":"3d5051cf527d13af27a8","49":"e40dd88068b85aee115c","50":"ebb4699ae9b1bc76fb26","51":"f4809091b284760de353","52":"7f127c4981cf16118446","53":"554a48157413f8af4fa8","54":"0681542e95bd33b4490a","55":"ab35bc2304a07988e419","56":"fdc0ab1d995bfb224792","57":"a28995086fa5d159f480","58":"5056cc40d6ad14af6ed9","59":"dc7ab3c9e399e081f9e7","60":"3fcf3b2775e1e98ee86f","61":"7e6fd92591c6476fd3ac","62":"ae5f35b1b2e087a666b0","63":"daa12609616738b4eae1","64":"77eb3dccb210b3fd2a21","65":"0c7c660121401a05c49f","66":"bcf9046776056b327d25","67":"78e69398ed027e30f31c","68":"dd169c9662c3a017ad3b","69":"ba01c12583bf0f0ce8d6","70":"9c98d37e3eedd885ffbb","71":"68fac6d07dbb8c818d7c","73":"338f3f943f399229e00b","74":"91686d4d9d52d843a972","75":"018fa0e637e68794e80f","76":"b0e8a121dd9a259973f2","77":"b09e6202447f97183d0d","78":"1bc657255e2022d91f02","79":"acd10752896dbae718d5","80":"a6230a307bbcbf8b4380","81":"621e4d8f900d4c60eb9f","83":"83b37e346e49dc6b5b8e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"15":1,"16":1,"17":1,"18":1,"19":1,"24":1,"28":1,"29":1,"30":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"40":1,"41":1,"45":1,"48":1,"49":1,"50":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"65":1,"66":1,"67":1,"69":1,"75":1,"77":1,"78":1,"79":1,"80":1,"81":1,"83":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~w~39769c46","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","7":"buybox~quick-view~write-a-review-form","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~emt-generated-content","15":"buybox~quick-view","16":"buybox~super-sku","17":"media-gallery-overlay~media-gallery-overlay-mobile","18":"promotion-products-lazy~quick-view","19":"quick-view~write-a-review-form","22":"StoreLayout","23":"add-to-list-drawer","24":"aisle-bay","25":"augmented-reality","26":"bath-renovation","27":"breadcrumbs","28":"browse-and-search","29":"browse-and-search-mobile","30":"buybox","31":"calculator-pipcalculator","32":"collections","33":"collections-mobile","34":"compare","35":"consumer-card-messaging","36":"customer-image-overlay","37":"drawer","38":"emt-generated-content","39":"emt-links","40":"fbr","41":"global-custom-configurator","42":"hammerjs","44":"home","45":"magic-apron","46":"measurement-guide","47":"measurement-guide-overlay-content","48":"media-gallery-filmstrip-mobile","49":"media-gallery-overlay","50":"media-gallery-overlay-mobile","51":"message-types","52":"orange-lens","53":"order-sample","54":"order-sample-drawer","55":"overlay","56":"paint-reorder","57":"paint-reorder-mobile","58":"pep","59":"pep-mobile","60":"product","61":"product-mobile","62":"product-overview","63":"promotion-products-lazy","64":"question","65":"questions-and-answers","66":"quick-view","67":"ratings-and-reviews","68":"ratings-and-reviews-desktop","69":"ratings-and-reviews-mobile","70":"results","71":"returns-messaging","73":"share-to-email-overlay","74":"share-to-pinterest-overlay","75":"size-guide-overlay","76":"specifications","77":"stylequiz","78":"super-sku","79":"vendor-collection-products","80":"vendor-collections","81":"vendor-collections-mobile","83":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"122077d17b60cda2f019","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"7647b1510da5618b37af","5":"89d9163eeb30e835d559","6":"83588448fb37280fe4ec","7":"7647b1510da5618b37af","8":"0ef658ad0521bc70e648","9":"6fd9a33d658b6409b465","10":"50d430c72ccc3cf96a34","11":"7c2eed0c18c49e42c517","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"846fc64d5dfa68c15d2e","16":"576efaf8352e8d280a13","17":"2d109bd7bcce838cd33b","18":"f37181d0925448e2b0c3","19":"36a78bdfd0b254f7c6bc","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"86b1f984e52a6e02026d","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"62835b018b99e9533c60","29":"68da1228a2014ff4f6d3","30":"e32d2dad07c998b43796","31":"31d6cfe0d16ae931b73c","32":"2c0fa41113fab4452236","33":"5f560fd3a263ce7a3f46","34":"efe0cbab4890f136684d","35":"360d85a0ef189bc707ce","36":"c466036523aec2558c34","37":"fc73174b407ad863c497","38":"b49004ddac99adec2224","39":"31d6cfe0d16ae931b73c","40":"88e24c7aafcf93ae6cc6","41":"1a5562a08d12f7682989","42":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"ceebf150d8a696023a14","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"c185dd507b97bcc2bd63","49":"febd47ef260523f73f95","50":"28eeeffa9372934ea706","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"6b54052876330d2b283a","56":"e45de0290126aa77fe5b","57":"e131d5f0dec726a41eec","58":"ad4390832090a4480b25","59":"cfceaac20f3957404ab9","60":"8fdf9ff22eea651786fa","61":"7c2359ffe09ff3fd6dde","62":"be155bb5d11dacdc4bb8","63":"ccd67317cd6af4c4a68d","64":"31d6cfe0d16ae931b73c","65":"d70c859b20e57c1599c5","66":"a67c67d058149c1b8fa6","67":"8bab1a752ffbe17a3eb7","68":"31d6cfe0d16ae931b73c","69":"2ade42f7647d0b013747","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"453dfc2640779a848cc6","76":"31d6cfe0d16ae931b73c","77":"6c6bdd949ddd0752832b","78":"0425b135a55a0ec65fde","79":"e518e335254638969e62","80":"2524eb3d9654c5f13a24","81":"41ed6aae6b4c6a9de506","83":"5512b06edf556d72360f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
